
import { useState } from "react";
import { FeedbackDialog } from "./ui/feedback-dialog";
import { Button } from "./ui/button";
import { MessageCircle } from "lucide-react";

interface FeedbackSectionProps {
  toolName: string;
  onFeedbackSubmit?: () => void;
}

export const FeedbackSection = ({ toolName, onFeedbackSubmit }: FeedbackSectionProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    if (onFeedbackSubmit) {
      onFeedbackSubmit();
    }
  };

  return (
    <div className="mt-8 p-4 bg-gray-50 rounded-lg">
      <div className="flex flex-col items-center gap-4">
        <p className="text-sm text-gray-600">Comment évaluez-vous cet outil ?</p>
        <Button
          variant="outline"
          onClick={() => setIsDialogOpen(true)}
          className="w-full sm:w-auto"
        >
          <MessageCircle className="mr-2 h-4 w-4" />
          Donner mon avis
        </Button>
      </div>

      <FeedbackDialog
        isOpen={isDialogOpen}
        onClose={handleDialogClose}
        toolName={toolName}
      />
    </div>
  );
};
